import { useState } from 'react';
import AppShell from '../components/layout/AppShell';
import AppFooter from '../components/layout/AppFooter';
import TopNav from '../components/layout/TopNav';

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

const QUESTIONS = [
    {
        id: 0,
        section: "Vos coordonnées",
        question: "Votre prénom (ou nom d'entreprise)",
        type: "text",
    },
    {
        id: 1,
        section: "Votre situation",
        question: "Quel est votre statut ?",
        type: "single",
        options: ["Particulier", "Auto-entrepreneur / micro-entreprise", "Freelance / indépendant", "PME (1–10 employés)", "PME (10–20 employés)", "Autre"],
    },
    {
        id: 2,
        section: "Votre situation",
        question: "Votre activité dépend-elle fortement de votre ordinateur ?",
        type: "single",
        options: ["Oui, totalement", "Oui, assez souvent", "Moyennement", "Peu"],
    },
    {
        id: 3,
        section: "Vos problèmes",
        question: "À quelle fréquence avez-vous des problèmes informatiques ?",
        type: "single",
        options: ["Plusieurs fois par semaines", "1 fois par semaine", "1 fois par mois ou plus", "Tous les 2–3 mois", "Rarement"],
    },
    {
        id: 4,
        section: "Vos problèmes",
        question: "Quels types de problèmes rencontrez-vous le plus ?",
        type: "multi",
        options: ["Ordinateur lent", "Problèmes d'imprimante", "Wi-Fi / réseau", "Logiciels (Office, comptabilité…)", "Virus / sécurité", "Installation de nouveaux outils", "Autre"],
    },
    {
        id: 5,
        section: "Vos problèmes",
        question: "Comment résolvez-vous ces problèmes aujourd'hui ?",
        type: "multi",
        options: ["Je cherche sur Google / YouTube", "Je demande à un ami ou collègue", "Je contacte un informaticien", "Je fais avec le problème", "Autre"],
    },
    {
        id: 6,
        section: "L'impact",
        question: "Quand votre ordinateur ne fonctionne pas, quel est l'impact ?",
        type: "single",
        options: ["Mon travail est totalement bloqué", "Je perds du temps mais je peux continuer", "Peu d'impact"],
    },
    {
        id: 7,
        section: "L'impact",
        question: "Avez-vous actuellement un support informatique ?",
        type: "single",
        options: ["Oui, interne", "Oui, prestataire externe", "Non"],
    },
    {
        id: 8,
        section: "Notre service",
        question: "Seriez-vous intéressé par un dépannage informatique à distance en moins de 15 minutes ?",
        type: "single",
        options: ["Oui certainement", "Peut-être", "Non"],
    },
    {
        id: 9,
        section: "Notre service",
        question: "Quel prix vous semblerait raisonnable pour résoudre un problème simple (10–15 minutes) ?",
        type: "single",
        options: ["Moins de 20 €", "20–30 €", "30–50 €", "Plus de 50 €"],
    },
    {
        id: 10,
        section: "Abonnement",
        question: "Seriez-vous intéressé par un abonnement incluant un support informatique rapide ?",
        type: "single",
        options: ["Oui", "Peut-être", "Non"],
    },
    {
        id: 11,
        section: "Abonnement",
        question: "Si oui, quel prix par mois ?",
        type: "single",
        options: ["5–10 €", "10–20 €", "20–50 €", "Plus de 50 €"],
        condition: (answers) => answers[10] === "Oui" || answers[10] === "Peut-être",
    },
    {
        id: 12,
        section: "Pour finir",
        question: "Quel est votre plus gros problème informatique aujourd'hui ?",
        type: "text",
    },
    {
        id: 13,
        section: "Pour finir",
        question: "Seriez-vous intéressé pour tester le service lorsqu'il sera disponible ?",
        type: "single",
        options: ["Oui", "Non"],
        note: "Votre email ne sera utilisé que pour vous informer du lancement. Aucune publicité, aucun spam.",
    },
];

const styles = {
    container: { maxWidth: 640, margin: '0 auto', padding: '28px 20px' },
    intro: {
        padding: '28px 24px',
        borderRadius: 16,
        background: 'rgba(110,86,207,0.06)',
        border: '1px solid rgba(110,86,207,0.18)',
        marginBottom: 32,
    },
    introTitle: { fontSize: 22, fontWeight: 800, margin: '0 0 10px', letterSpacing: '-0.02em' },
    introDesc: { fontSize: 14, color: 'rgba(200,200,215,0.75)', lineHeight: 1.65, margin: 0 },
    progressWrap: { marginBottom: 28 },
    progressBar: {
        height: 4, borderRadius: 999, background: 'rgba(255,255,255,0.06)', overflow: 'hidden',
    },
    progressFill: (pct) => ({
        height: '100%', borderRadius: 999,
        background: 'linear-gradient(90deg, #6E56CF, #a78bfa)',
        width: `${pct}%`, transition: 'width 0.4s ease',
    }),
    progressText: { fontSize: 12, color: 'rgba(180,180,200,0.5)', marginTop: 6 },
    sectionLabel: {
        fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase',
        color: '#6E56CF', marginBottom: 8,
    },
    questionCard: {
        padding: '24px',
        borderRadius: 14,
        background: 'rgba(255,255,255,0.025)',
        border: '1px solid rgba(255,255,255,0.06)',
        marginBottom: 16,
    },
    questionText: { fontSize: 15, fontWeight: 600, margin: '0 0 16px', lineHeight: 1.5 },
    option: (selected) => ({
        display: 'flex', alignItems: 'center', gap: 10,
        padding: '11px 14px', borderRadius: 10, cursor: 'pointer',
        marginBottom: 6, fontSize: 14, transition: 'all 0.15s ease',
        background: selected ? 'rgba(110,86,207,0.12)' : 'rgba(255,255,255,0.025)',
        border: `1px solid ${selected ? 'rgba(110,86,207,0.4)' : 'rgba(255,255,255,0.06)'}`,
        color: selected ? '#fff' : 'rgba(220,220,235,0.85)',
    }),
    radio: (selected) => ({
        width: 18, height: 18, borderRadius: 999, flexShrink: 0,
        border: `2px solid ${selected ? '#6E56CF' : 'rgba(255,255,255,0.18)'}`,
        background: selected ? '#6E56CF' : 'transparent',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'all 0.15s ease',
    }),
    checkbox: (selected) => ({
        width: 18, height: 18, borderRadius: 5, flexShrink: 0,
        border: `2px solid ${selected ? '#6E56CF' : 'rgba(255,255,255,0.18)'}`,
        background: selected ? '#6E56CF' : 'transparent',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'all 0.15s ease',
        fontSize: 11, color: '#fff', fontWeight: 800,
    }),
    textarea: {
        width: '100%', minHeight: 80, padding: '12px 14px', borderRadius: 10,
        background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)',
        color: '#fff', fontSize: 14, fontFamily: 'inherit', resize: 'vertical',
        outline: 'none', boxSizing: 'border-box',
    },
    emailInput: {
        width: '100%', padding: '11px 14px', borderRadius: 10, marginTop: 10,
        background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)',
        color: '#fff', fontSize: 14, fontFamily: 'inherit',
        outline: 'none', boxSizing: 'border-box',
    },
    submitBtn: (disabled) => ({
        width: '100%', padding: '14px 0', borderRadius: 12, fontSize: 15, fontWeight: 700,
        background: disabled ? 'rgba(110,86,207,0.15)' : '#6E56CF',
        border: 'none', color: disabled ? 'rgba(255,255,255,0.3)' : '#fff',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.2s ease', marginTop: 20,
    }),
    success: {
        textAlign: 'center', padding: '60px 24px',
        borderRadius: 16, background: 'rgba(110,86,207,0.06)',
        border: '1px solid rgba(110,86,207,0.18)',
    },
    successIcon: { fontSize: 48, marginBottom: 16 },
    successTitle: { fontSize: 22, fontWeight: 800, margin: '0 0 10px' },
    successDesc: { fontSize: 14, color: 'rgba(200,200,215,0.75)', margin: 0, lineHeight: 1.6 },
};

export default function Survey({ onLogout, onNavigate, isLoggedIn }) {
    const [answers, setAnswers] = useState({});
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const visibleQuestions = QUESTIONS.filter(q => !q.condition || q.condition(answers));
    const answeredCount = visibleQuestions.filter(q => answers[q.id] !== undefined && answers[q.id] !== '').length;
    const progress = Math.round((answeredCount / visibleQuestions.length) * 100);

    function handleSingle(qId, value) {
        setAnswers(prev => ({ ...prev, [qId]: value }));
    }

    function handleMulti(qId, value) {
        setAnswers(prev => {
            const current = prev[qId] || [];
            if (current.includes(value)) {
                return { ...prev, [qId]: current.filter(v => v !== value) };
            }
            return { ...prev, [qId]: [...current, value] };
        });
    }

    function handleText(qId, value) {
        setAnswers(prev => ({ ...prev, [qId]: value }));
    }

    async function handleSubmit() {
        setSubmitting(true);
        try {
            const payload = {
                answers,
                email: answers[13] === 'Oui' ? email : null,
                submitted_at: new Date().toISOString(),
            };
            await fetch(`${API}/survey`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
        } catch (err) {
            console.error('Erreur envoi sondage:', err);
        }
        setSubmitted(true);
        setSubmitting(false);
    }

    if (submitted) {
        return (
            <AppShell
                header={<TopNav isLoggedIn={isLoggedIn} onLogout={onLogout} onNavigate={onNavigate} />}
                footer={<AppFooter onNavigate={onNavigate} />}
                onNavigate={onNavigate}
            >
                <div style={styles.container}>
                    <div style={styles.success}>
                        <div style={styles.successIcon}>🎉</div>
                        <h2 style={styles.successTitle}>Merci pour votre participation !</h2>
                        <p style={styles.successDesc}>
                            Vos réponses nous aident à construire un service qui correspond vraiment à vos besoins.
                            {answers[13] === 'Oui' && ' Nous vous contacterons dès que le service sera disponible.'}
                        </p>
                    </div>
                </div>
            </AppShell>
        );
    }

    let currentSection = '';

    return (
        <AppShell
            header={<TopNav isLoggedIn={isLoggedIn} onLogout={onLogout} onNavigate={onNavigate} />}
            footer={<AppFooter onNavigate={onNavigate} />}
            onNavigate={onNavigate}
        >
            <div style={styles.container}>
                {/* Intro */}
                <div style={styles.intro}>
                    <h1 style={styles.introTitle}>Aidez-nous à mieux vous aider</h1>
                    <p style={styles.introDesc}>
                        Ce sondage prend 2 minutes et nous aide à construire le meilleur service de dépannage informatique à distance.
                    </p>
                </div>

                {/* Progress */}
                <div style={styles.progressWrap}>
                    <div style={styles.progressBar}>
                        <div style={styles.progressFill(progress)} />
                    </div>
                    <div style={styles.progressText}>{answeredCount} / {visibleQuestions.length} questions</div>
                </div>

                {/* Questions */}
                {visibleQuestions.map((q) => {
                    const showSection = q.section !== currentSection;
                    if (showSection) currentSection = q.section;

                    return (
                        <div key={q.id}>
                            {showSection && (
                                <div style={{ ...styles.sectionLabel, marginTop: q.id === 1 ? 0 : 28 }}>
                                    {q.section}
                                </div>
                            )}
                            <div style={styles.questionCard}>
                                <p style={styles.questionText}>{q.question}</p>

                                {q.type === 'single' && q.options.map(opt => {
                                    const selected = answers[q.id] === opt;
                                    return (
                                        <div key={opt}>
                                            <div style={styles.option(selected)} onClick={() => handleSingle(q.id, opt)}>
                                                <div style={styles.radio(selected)}>
                                                    {selected && <div style={{ width: 8, height: 8, borderRadius: 999, background: '#fff' }} />}
                                                </div>
                                                {opt}
                                            </div>
                                            {opt === 'Autre' && selected && (
                                                <input
                                                    type="text"
                                                    placeholder="Précisez..."
                                                    value={answers[`${q.id}_autre`] || ''}
                                                    onChange={(e) => handleText(`${q.id}_autre`, e.target.value)}
                                                    onClick={(e) => e.stopPropagation()}
                                                    style={{ ...styles.emailInput, marginTop: 4, marginBottom: 6 }}
                                                />
                                            )}
                                        </div>
                                    );
                                })}

                                {q.type === 'multi' && q.options.map(opt => {
                                    const selected = (answers[q.id] || []).includes(opt);
                                    return (
                                        <div key={opt}>
                                            <div style={styles.option(selected)} onClick={() => handleMulti(q.id, opt)}>
                                                <div style={styles.checkbox(selected)}>
                                                    {selected && '✓'}
                                                </div>
                                                {opt}
                                            </div>
                                            {opt === 'Autre' && selected && (
                                                <input
                                                    type="text"
                                                    placeholder="Précisez..."
                                                    value={answers[`${q.id}_autre`] || ''}
                                                    onChange={(e) => handleText(`${q.id}_autre`, e.target.value)}
                                                    onClick={(e) => e.stopPropagation()}
                                                    style={{ ...styles.emailInput, marginTop: 4, marginBottom: 6 }}
                                                />
                                            )}
                                        </div>
                                    );
                                })}

                                {q.type === 'text' && (
                                    <textarea
                                        style={styles.textarea}
                                        placeholder="Votre réponse..."
                                        value={answers[q.id] || ''}
                                        onChange={(e) => handleText(q.id, e.target.value)}
                                    />
                                )}

                                {q.id === 13 && answers[13] === 'Oui' && (
                                    <input
                                        type="email"
                                        style={styles.emailInput}
                                        placeholder="votre@email.com"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                )}
                                {q.note && (
                                    <p style={{ fontSize: 12, color: 'rgba(180,180,200,0.5)', marginTop: 8, fontStyle: 'italic' }}>
                                        🔒 {q.note}
                                    </p>
                                )}
                            </div>
                        </div>
                    );
                })}

                {/* Submit */}
                <button
                    style={styles.submitBtn(submitting)}
                    onClick={handleSubmit}
                    disabled={submitting}
                >
                    {submitting ? 'Envoi en cours...' : 'Envoyer mes réponses'}
                </button>
            </div>
        </AppShell>
    );
}
